import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-no-membership-popup',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './no-membership-popup.component.html',
  styleUrl: './no-membership-popup.component.css'
})
export class NoMembershipPopupComponent {
  @Input() visible = false;
  @Input() header = 'shared.membership_ended';
  @Input() description = 'shared.membership_ended_desc';
}
